import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { puzzleApi } from '../utils/api'

const styles = {
  hero: {
    textAlign: 'center',
    padding: '48px 0',
    borderBottom: '2px solid var(--color-border)',
    marginBottom: '48px',
  },
  heroTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    marginBottom: '16px',
  },
  heroSubtitle: {
    fontSize: '1.25rem',
    color: 'var(--color-muted)',
    marginBottom: '32px',
  },
  createBtn: {
    display: 'inline-block',
    padding: '16px 32px',
    background: 'var(--color-primary)',
    color: '#fff',
    border: '2px solid var(--color-border)',
    fontWeight: '600',
    fontSize: '1.125rem',
    textDecoration: 'none',
  },
  section: {
    marginBottom: '48px',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '24px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '24px',
  },
  card: {
    border: '2px solid var(--color-border)',
    padding: '20px',
    textDecoration: 'none',
    color: 'inherit',
    transition: 'transform 0.15s, box-shadow 0.15s',
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    marginBottom: '8px',
  },
  cardMeta: {
    fontSize: '0.875rem',
    color: 'var(--color-muted)',
    marginBottom: '12px',
  },
  cardStats: {
    display: 'flex',
    gap: '16px',
    fontSize: '0.875rem',
  },
  stat: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  statValue: {
    fontWeight: '600',
  },
  empty: {
    textAlign: 'center',
    padding: '48px',
    color: 'var(--color-muted)',
    border: '2px dashed var(--color-border)',
  },
  loading: {
    textAlign: 'center',
    padding: '48px',
    color: 'var(--color-muted)',
  },
}

function formatTime(seconds) {
  if (!seconds) return '--'
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

export default function Home() {
  const [puzzles, setPuzzles] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchPuzzles() {
      try {
        const data = await puzzleApi.list(20)
        setPuzzles(data.puzzles || [])
      } catch (err) {
        console.error('Failed to fetch puzzles:', err)
        setPuzzles([])
      } finally {
        setLoading(false)
      }
    }

    fetchPuzzles()
  }, [])

  return (
    <div>
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Kellyword</h1>
        <p style={styles.heroSubtitle}>
          Create puzzles, share them with friends, and compete on solve times
        </p>
        <Link to="/create" style={styles.createBtn}>
          Create a Puzzle
        </Link>
      </div>

      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Recent Puzzles</h2>

        {loading ? (
          <div style={styles.loading}>Loading puzzles...</div>
        ) : puzzles.length === 0 ? (
          <div style={styles.empty}>
            <p>No puzzles yet. Be the first to create one!</p>
          </div>
        ) : (
          <div style={styles.grid}>
            {puzzles.map(puzzle => (
              <Link
                key={puzzle.id}
                to={`/puzzle/${puzzle.id}`}
                style={styles.card}
              >
                <h3 style={styles.cardTitle}>{puzzle.theme || 'Untitled'}</h3>
                <p style={styles.cardMeta}>
                  {puzzle.gridSize}×{puzzle.gridSize}
                  {puzzle.creatorName && ` · By ${puzzle.creatorName}`}
                </p>
                <div style={styles.cardStats}>
                  <span style={styles.stat}>
                    <span style={styles.statValue}>{puzzle.solveCount || 0}</span>
                    <span>solves</span>
                  </span>
                  <span style={styles.stat}>
                    <span>Avg:</span>
                    <span style={styles.statValue}>{formatTime(puzzle.avgSolveTime)}</span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
